import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

export const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#F5F6FA',
          surface: '#FFFFFF',
          'surface-variant': '#F0F2F5',
          primary: '#0052CC',
          secondary: '#6554C0',
          accent: '#00B8D9',
          error: '#DE350B',
          warning: '#FF991F',
          success: '#36B37E',
          info: '#0065FF',
          'on-background': '#172B4D',
          'on-surface': '#172B4D',
        },
      },
      dark: {
        dark: true,
        colors: {
          background: '#1B1D21',
          surface: '#232529',
          'surface-variant': '#2C2E33',
          primary: '#4C9AFF',
          secondary: '#998DD9',
          accent: '#00C7E6',
          error: '#FF5630',
          warning: '#FFAB00',
          success: '#57D9A3',
          info: '#4C9AFF',
          'on-background': '#E1E4E8',
          'on-surface': '#E1E4E8',
        },
      },
    },
  },
  defaults: {
    VBtn: { variant: 'flat', rounded: 'lg', density: 'comfortable' },
    VCard: { rounded: 'lg', elevation: 0 },
    VTextField: { variant: 'outlined', density: 'compact' },
    VSelect: { variant: 'outlined', density: 'compact' },
    VChip: { density: 'compact' },
  },
});
